var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('mission-detail-graphics',{attrs:{"sciGraph":true,"isleft":_vm.isleft,"uiid":_vm.uiid,"mission":_vm.currentDetailMission.mission,"tabState":_vm.currentDetailMission}})
}
var staticRenderFns = []

export { render, staticRenderFns }